import { render, staticRenderFns } from "./create-page-drawer.vue?vue&type=template&id=d9945ca0&"
import script from "./create-page-drawer.vue?vue&type=script&lang=js&"
export * from "./create-page-drawer.vue?vue&type=script&lang=js&"
import style0 from "./create-page-drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports